import type { RouteRecordRaw } from "vue-router";

export const courseEnrollmentsRoutes: RouteRecordRaw[] = [
  {
    path: "/course_enrollments",
    name: "course_enrollments",
    component: () => import("./CourseEnrollmentListPage.vue"),
    meta: {
      title: "courseEnrollments.headers.title",
    },
  },
];
